var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenFilledTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: "#00A521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6958 8.91448L6.60753 11.8262L13.3045 5.42041",
    stroke: "#DEFFE8",
    strokeWidth: 2.21739
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFilledTickIcon);
export default __webpack_public_path__ + "static/media/green-filled-tick-icon.22022c6e7ba3c4c609c4609927beb4a9.svg";
export { ForwardRef as ReactComponent };